<template>
  <section>
	<ul class="menu">
		<li v-for="menu in menus" :key="menu">
		<router-link :to="'/' + menu.toLowerCase()" active-class="active">{{ menu }}</router-link>
		</li> 
	</ul>
	<router-view></router-view>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const menus = ref(['Work', 'About'])

</script>